import { apiUrl } from '../../../settings'

export const listAllAbstractUrl = () => {
  return apiUrl + '/online-abstract-list'
}

export const addAbstractUrl = () => {
  return apiUrl + '/online-abstract'
}
export const deleteAbstractUrl = () => {
  return apiUrl + '/online-abstract/delete'
}
export const updateAbstractUrl = () => {
  return apiUrl + '/online-abstract/update'
}
export const sendAbstractEmailUrl = () => {
  return apiUrl + '/online-abstract/send-email'
}
export const addAbstractNoteUrl = () => {
  return apiUrl + '/online-abstract/add-note'
}
export const listAbstractNotesUrl = () => {
  return apiUrl + '/online-abstract/notes-list'
}
export const listAbstractActivityUrl = () => {
  return apiUrl + '/online-abstract/activity-list'
}
export const selectAbstractEmailUrl = (id) => {
  return apiUrl + `/online-abstract/email/${id}`
}
export const lastAbstractNoUrl = () => {
  return apiUrl + `/lastAbstractNo`
}
// software
export const createAbstractUrl = () => {
  return apiUrl + '/abstract/add'
}
export const getSingleOnlineAbstractUrl = (id) => {
  return apiUrl + `/get-single-online-abstract/${id}`
}
export const proceedAbstractSubmissionUrl = () => {
  return apiUrl + '/online-abstract/proceed-submission'
}
export const listAbstractsUrl = () => {
  return apiUrl + '/abstract/submitted-abstracts'
}
export const getSingleAbstractUrl = (id) => {
  return apiUrl + `/get-single-abstract/${id}`
}
export const updateApprovedAbstractUrl = () => {
  return apiUrl + '/abstract/update'
}
export const generateGraphicalAbstractUrl = () => {
  return apiUrl + '/abstract/generate-graphical-abstract'
}
